var $ = require('jquery');

let shareContainer;
let postTitle;
let featuredImage;
let relatedPosts;
let initialPointOfShow;
let relatedPostPos;

jQuery(window).on('load', function() {
    if ( jQuery('.single').length ) {
        shareContainer = $('.single').find('.post__share');
        postTitle = $('.single').find('.post__header');
        featuredImage = $('.single').find('.post__featured-visual');
        relatedPosts = $('.single').find('.post__related-posts');
        initialPointOfShow = 0;
        relatedPostPos = relatedPosts.offset().top;

        if ( featuredImage.length )  {
            initialPointOfShow = featuredImage.offset().top + featuredImage.height();
        } else {
            initialPointOfShow = postTitle.offset().top;
        }
    }
    
    jQuery(window).on('scroll', function() {
        if ( jQuery('.single').length ) { 
            // console.log($(window).scrollTop() + (window.innerHeight / 2), relatedPostPos);
            if ( $(window).scrollTop() <= initialPointOfShow || $(window).scrollTop() + (window.innerHeight / 2) >= relatedPostPos ) {
                shareContainer.removeClass('animate-in');
            } else if ( $(window).scrollTop() > initialPointOfShow && $(window).scrollTop() + (window.innerHeight / 2) < relatedPostPos ) {
                shareContainer.addClass('animate-in');
            }
        }
    })
});

jQuery(document).ready(function () {
    animateBlocks();
});

// - - - Animate blocks - - -
function animateBlocks() {
    jQuery(window).on("scroll touchstart resize", function () {
        jQuery(".js-animated-block").each(function () {

            // ----- same shift all the time ------
            // addAnimationClassIfInViewport($(this), 250);

            // belows are examples.
            // Use as many if as required or simply stay with basic shift for all animations like above
            // do not use 2 diff if else. All must be under the same if else

            // ----- mobile VS desktop example ------
            if (window.innerWidth > 780) {
              addAnimationClassIfInViewport($(this), 250)
            } else {
              addAnimationClassIfInViewport($(this), 100);
            }

            // ----- diff page example ------
            /* if ( $(this).hasClass("latest-feed")) {
              addAnimationClassIfInViewport($(this), 300)
            } else {
              addAnimationClassIfInViewport($(this), 400);
            }*/

        })
    }).trigger("resize");
    setTimeout(function () { jQuery(window).trigger("resize"); }, 2500);
}

// - - - Check if element is in viewport - - -
function isInViewport(elem, shift) {
    var elementTop = elem.offset().top + shift;
    var elementBottom = elementTop + elem.outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

// - - - Add class to animated block - - -
function addAnimationClassIfInViewport(elem, shift) {
    if (isInViewport(elem, shift)) {
        if (!elem.hasClass("")) {
          elem.trigger("enterview");
        }
        elem.addClass("animated-block");
        elem.removeClass("animated-block-out"); 
    } else if (elem.hasClass("animated-block")) {
        
        if (!elem.hasClass("animated-out-block")) {
          elem.trigger("exitview");
          elem.addClass("animated-out-block"); 
          elem.removeClass("animated-block"); 
        }
        //elem.removeClass("animated-block");  // <- comment this out to remove the reverse animation
    }
}